import { useLanguage } from './language-context';

// en/bn switch in the footer (i18n toggle, CLAUDE.md), drawn as the design's sliding
// track (DC:3610). Persists via the language
// context; every screen re-renders with the new dictionary.
export function LanguageToggle() {
  const { lang, setLang, t } = useLanguage();
  return (
    <div className="lang-toggle" data-lang={lang} role="group" aria-label={t('app.language')}>
      <button
        type="button"
        className={lang === 'en' ? 'lang-toggle__opt is-active' : 'lang-toggle__opt'}
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
      >
        <span aria-hidden="true">{t('lang.en_short')}</span>
        <span className="visually-hidden">{t('lang.en')}</span>
      </button>
      <button
        type="button"
        className={lang === 'bn' ? 'lang-toggle__opt is-active' : 'lang-toggle__opt'}
        aria-pressed={lang === 'bn'}
        onClick={() => setLang('bn')}
      >
        <span aria-hidden="true">{t('lang.bn_short')}</span>
        <span className="visually-hidden">{t('lang.bn')}</span>
      </button>
    </div>
  );
}
